import { createSelector } from 'reselect';
import idx from 'idx';
import { IReduxState } from 'scripts/reducers/reducer.interfaces';
import { IUserState } from 'scripts/reducers/user-service-reducer';

const selectUser = (state: IReduxState): IUserState => state.user;

const selectHeartbeat = createSelector(
  selectUser,
  user => user.heartbeat,
);

export const selectHeartbeatData = createSelector(
  selectHeartbeat,
  heartbeat => heartbeat.data,
);

export const selectRallyId = createSelector(
  selectHeartbeatData,
  heartbeat => idx(heartbeat, _ => _.rallyId),
);

export const selectIsSuperUser = createSelector(
  selectHeartbeatData,
  heartbeat => idx(heartbeat, _ => _.isSuperUser),
);

export const selectSessionIdp = createSelector(
  selectHeartbeatData,
  heartbeat => idx(heartbeat, _ => _.sessionIdp),
);
